import { render, staticRenderFns } from "./SwitchId.vue?vue&type=template&id=3ea2849d&scoped=true"
import script from "./SwitchId.vue?vue&type=script&lang=js"
export * from "./SwitchId.vue?vue&type=script&lang=js"
import style0 from "./SwitchId.vue?vue&type=style&index=0&id=3ea2849d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea2849d",
  null
  
)

export default component.exports